import React, { Component } from 'react'
import Media from 'sb-media'
import actions from 'redux/actions'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import Button from 'components/buttons/Button/Button'
import Picture from 'components/ui/Picture/Picture'

import messages from './messages'
import s from './QueueTutorialModal.scss'

// resolve picture x2
import desktopTutorial1 from './images/desktop/tutorial1.jpg'
// resolve picture x2
import desktopTutorial2 from './images/desktop/tutorial2.jpg'
// resolve picture x2
import desktopTutorial3 from './images/desktop/tutorial3.jpg'
// resolve picture x2
import mobileTutorial1 from './images/mobile/tutorial1.jpg'
// resolve picture x2
import mobileTutorial2 from './images/mobile/tutorial2.jpg'
// resolve picture x2
import mobileTutorial3 from './images/mobile/tutorial3.jpg'


class QueueTutorialModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object,
  }

  static defaultProps = {
    name: constants.modals.QueueTutorial,
  }

  state = {
    tutorialStep: 1,
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  goNextStep = () => {
    const { tutorialStep } = this.state

    if (tutorialStep !== 3) {
      this.setState({
        tutorialStep: tutorialStep + 1,
      })
    }
    else {
      this.close()
    }
  }

  render() {
    const { tutorialStep } = this.state
    const { name } = this.props

    const isLastStep = tutorialStep === 3
    const tutorial   = messages[`tutorial${tutorialStep}`]

    const tutorialDesktop = [
      desktopTutorial1,
      desktopTutorial2,
      desktopTutorial3,
    ][tutorialStep - 1]

    const tutorialMobile = [
      mobileTutorial1,
      mobileTutorial2,
      mobileTutorial3,
    ][tutorialStep - 1]

    return (
      <Modal
        className={s.queueTutorialModal}
        name={name}
        title={isLastStep ? messages.titleProduct : messages.titleQueue}
      >
        <FormattedHTMLMessage className={s.tutorial} tag="div" {...tutorial} />
        <Media mobile>
          {
            (isMobile) => (
              <Picture className={s.image} fullWidth {...(isMobile ? tutorialMobile : tutorialDesktop)} />
            )
          }
        </Media>
        <div className={s.buttons}>
          <div>
            {
              !isLastStep && (
                <Button
                  className={s.exitButton}
                  lightGray
                  md
                  title={messages.exit}
                  onClick={this.close}
                />
              )
            }
          </div>
          <Button
            brand
            md
            title={isLastStep ? messages.finish : messages.next}
            onClick={this.goNextStep}
          />
        </div>
      </Modal>
    )
  }
}


export default QueueTutorialModal
